import { jsx } from "react/jsx-runtime";
import { useTranslation } from "../../../../../contexts/translation-context.js";
import { classes } from "./indicators.st.css";
const Indicators = () => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(
    "div",
    {
      "aria-label": t(
        "form.appointment.accessibility.calendar.has-availability.aria-label"
      ),
      className: classes.root,
      children: /* @__PURE__ */ jsx("div", { className: classes.indicator })
    }
  );
};
export {
  Indicators
};
//# sourceMappingURL=index.js.map
